<template>
  <div class="landing-page">
    <!-- <banner-component type="info"></banner-component> -->
    <h1>{{ $t('W2P_LANDING_HEADER') }}</h1>
    <p>{{ $t('W2P_LANDING_SUB_HEADER') }}</p>
    <div class="service-card-container">
      <service-card-component
        v-for="service in filteredServices"
        :key="service.product"
        :service="service"
      ></service-card-component>
    </div>

    <latest-orders-component v-if="isLoggedIn"></latest-orders-component>
  </div>
</template>

<script>
// import BannerComponent from '@/components/banner/BannerComponent.vue'
import ServiceCardComponent from '@/components/service-card/ServiceCardComponent.vue'
import LatestOrdersComponent from '@/components/latest-orders/LatestOrdersComponent.vue'
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    // BannerComponent,
    ServiceCardComponent,
    LatestOrdersComponent
  },
  data() {
    return {
      redirectToRV: false
    }
  },
  created() {
    // Features are preloaded in main.js, just check the flag
    this.checkFeatureFlag('Created - Page mounted')
  },
  mounted() {
    // Handle browser back/forward navigation that bypasses Vue Router
    window.addEventListener('pageshow', this.handlePageShow)
    this.$store.dispatch('ServiceCards/fetchServices')
  },
  beforeUnmount() {
    window.removeEventListener('pageshow', this.handlePageShow)
  },
  beforeMount() {
    this.$store.dispatch('ServiceCards/fetchServices')
  },
  methods: {
    handlePageShow(event) {
      if (event.persisted) {
        // Page was restored from bfcache (back/forward button)
        this.checkFeatureFlag('PageShow - Restored from cache')
      }
    },
    checkFeatureFlag(logInfo = '') {
      const isOrderList = this.$route.path === '/order/list'
      this.redirectToRV = this.isRVRedirectEnabled

      if (process.env.NODE_ENV !== 'production') {
        console.log(
          `Feature flag check: ${logInfo} | redirectToRV: ${this.redirectToRV} | isOrderList: ${isOrderList}`
        )
      }

      if (this.redirectToRV && !isOrderList) {
        window.location.href = process.env.VUE_APP_RV_URL
      }
    }
  },
  watch: {
    // Re-evaluate if gb instance changes (e.g. after feature refresh)
    $gb: {
      deep: true,
      handler() {
        this.checkFeatureFlag('Watch - GB instance changed')
      }
    },
    $route() {
      this.checkFeatureFlag('Watch - Route changed')
    }
  },
  computed: {
    ...mapState('ServiceCards', ['services']),
    ...mapGetters(['isLoggedIn', 'isBusinessUser']),
    ...mapGetters('growthbook', ['isRVRedirectEnabled']),
    filteredServices() {
      return this.services.filter(service => {
        // Show ODR except for logged in private user
        if (service.route === 'odr') {
          return !(this.isLoggedIn && !this.isBusinessUser)
        }

        return true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.landing-page {
  width: 100%;
  .service-card-container {
    display: grid;
    grid-gap: 2em;
    grid-template-columns: repeat(auto-fill, minmax(25rem, 1fr));
    grid-auto-rows: 1fr;
    width: 100%;
    justify-items: center;
  }

  h1 {
    color: $black;
  }

  p {
    margin: 1.5rem 0 3rem;
    color: $gray700;
  }
}

@supports not (display: grid) {
  .landing-page {
    .service-card {
      margin: 0 2em 2em;
    }
  }
}
</style>
